// extracted by mini-css-extract-plugin
export default {"Desc":"Decs_Desc__VYibX","title":"Decs_title__LzQLs","desc":"Decs_desc__8XSgK","number":"Decs_number__ucZzE","show":"Decs_show__+zlLS","shownum":"Decs_shownum__8XTnb"};